module.exports = __webpack_public_path__ + "img/1.0712fd4e.png";